import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import loader from '../../images/loader.gif';
import { useCart } from '../Cart/CartContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HashLink } from 'react-router-hash-link';
import { Helmet } from 'react-helmet';

const Product = () => {
  const { itemID } = useParams(); // Capture itemID from the URL
  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);
  const [mainImage, setMainImage] = useState(''); // State for main image
  const [showOptions, setShowOptions] = useState(false);

  const handleButtonClick = () => {
    handleAddToCart(product); // Add the product to the cart
    setShowOptions(true); // Show the Checkout and Continue Shopping buttons
  };

  useEffect(() => {
    const apiKey = process.env.REACT_APP_API_KEY;

    const fetchProductDetails = async () => {
      try {
        const response = await fetch(`https://kmatadmin.worldpos.biz/Api/Item/${itemID}`, {
          headers: {
            'APIKey': apiKey,
          },
        });
        const data = await response.json();
        if (data.success) {
          setProduct(data.data); // Set the fetched product details
        } else {
          console.error('Error fetching product details:', data.errorMessage);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    const fetchImageData = async () => {
      try {
        const response = await fetch(`https://kmatadmin.worldpos.biz/Api/ImageData/${itemID}`, {
          headers: {
            'APIKey': apiKey,
          },
        });
        const data = await response.json();
        if (data.success) {
          setImages(data.data); // Set the fetched image data
          // Set the first image as the default main image
          if (data.data.length > 0) {
            setMainImage(`https://kmatadmin.worldpos.biz/Uploads/${data.data[0].imageID}.jpg`);
          }
        } else {
          console.error('Error fetching image data:', data.errorMessage);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    fetchProductDetails();
    fetchImageData();
  }, [itemID]);

  const { addToCart } = useCart();

  // Assuming addToCart adds the product to the cart correctly
  const handleAddToCart = (product) => {
   addToCart({
     ...product,
     quantity: 1,  // Ensure quantity is set properly
   });
   toast.success(product.itemName + ' Added To The Cart!', {
    position: "top-right",
    autoClose: 2000,
  });
 };

 const customScroll = (el) => {
  const yOffset = -90; // Adjust the offset
  const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({ top: y, behavior: 'smooth' }); // Smooth scrolling
};

  if (!product) {
    return <div className='h-screen w-screen flex items-center justify-center'><img src={loader} className='w-[100px]' alt="" /></div>;
  }

  
  return (
    <div className='w-full mt-24 sm:mt-28 mb-10'>
      <Helmet>
        <title>KMat | {product.itemName}</title>
      </Helmet>
      <h1 className='text-sm font-bold text-center text-black/50 lg:hidden font-karla'>Brand: <span className='text-cyan-600'>{product.brandName}</span></h1>
      <h1 className='text-sm text-center font-bold text-gray-400 font-overpass'>{product.itemID}</h1>
      <h1 className='text-3xl text-center font-bold my-4 text-gray-600 font-overpass'>{product.itemName}</h1>
      <div className='w-[95%] md:w-[85%] xl:w-[80%] 3xl:w-[70%] grid grid-cols-1 lg:grid-cols-2 mx-auto'>
        <div className='w-full mt-5'>
          <a rel="noreferrer" target='_blank' href={mainImage}>
            <img 
              src={mainImage || `https://kmat.worldpos.biz/Uploads/${product.itemID}.jpg`} 
              className='w-[90%] mx-auto md:h-[500px] object-contain' 
              alt={product.itemName} 
            />
           </a>
          <div className='flex items-center justify-center mt-4 gap-2 flex-wrap'>
            {images.map((img, idx) => (
                <img
                  key={img.imageID} 
                  src={`https://kmatadmin.worldpos.biz/Uploads/${img.imageID}.jpg`}  // Use imageID for thumbnail URL
                  className='w-[60px] sm:w-[100px] md:w-[160px]  md:h-[160px] cursor-pointer object-contain' 
                  alt={`Gallery ${idx}`} 
                  onClick={() => setMainImage(`https://kmatadmin.worldpos.biz/Uploads/${img.imageID}.jpg`)} // Update main image on click
                />
            ))}
          </div>
        </div>
        <div className='w-full flex flex-col justify-center items-center'>
          <h1 className='text-lg font-bold text-black/50 lg:block hidden font-karla'>Brand: <span className='text-cyan-600'>{product.brandName}</span></h1>
          <h1 className='text-3xl font-bold text-black/70 lg:block hidden lg:mt-0 lg:my-5 font-karla'>{product.itemName}</h1>
          <p className='text-[15px] md:text-lg text-center w-[90%] lg:w-[80%] text-black/60 font-karla mt-10 lg:mt-0'>{product.itemDescription}</p>
          <Link to='/contact-us'>
            <button className='px-4 py-2 mt-3 rounded-full font-karla bg-cyan-600/70 font-semibold text-white hover:bg-cyan-600/80'>
              Contact Us
            </button>
          </Link>
          {/* <p className='text-lg font-semibold my-5 font-karla'>${product.retailPrice}</p>*/}
          {/*
          <button onClick={handleButtonClick} className='px-4 py-2 mt-3 rounded-full font-karla bg-cyan-600/70 font-semibold text-white hover:bg-cyan-600/80'>
            Add to Cart
          </button>
          {showOptions && (
              <div className="mt-4 flex space-x-4">
                <Link to='/checkout'>
                  <button className="px-4 py-2 rounded-full font-karla bg-green-600/70 font-semibold text-white hover:bg-green-600/80">
                    Checkout
                  </button>
                </Link>
                <HashLink scroll={customScroll} to={`/store#${product.categorySubID}`}>
                  <button className="px-4 py-2 rounded-full font-karla bg-gray-600/70 font-semibold text-white hover:bg-gray-600/80">
                    Continue Shopping
                  </button>
                </HashLink>
              </div>
            )} */}
        </div>
      </div>
    </div>
  );
};

export default Product;
